module.exports = __webpack_public_path__ + "img/zw.6ac3949a.svg";